<template>
    <div>
        <page-header :heading="pageHeader.title" />
        <b-card no-body>
            <b-tabs card v-model="tabIndex">
                <b-tab title="Upload" active>
                    <span>Please select the file map to use:</span>
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                    <hr />
                    <drop-file :ref="'dropFile'" :mainContainerClass="'upload-main-override'" @change="handleChange" />
                    <b-button v-on:click="uploadFiles()" v-show="files.length > 0">Send to server</b-button>
                </b-tab>
                <b-tab title="Recent Uploads">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Filename</th>
                                <th>Process Attempts</th>
                                <th>Uploaded</th>
                                <th>Uploaded By</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(itm, idx) in uploadedFiles" :key="'filerow_' + idx">
                                <td><router-link :to="`/finance/supplierpayments/progress/${itm.id}`">{{itm.originalFilename}}</router-link></td>
                                <td>{{itm.processAttempts}}</td>
                                <td>
                                    {{itm.dateCreated | datetime}}
                                </td>
                                <td>{{itm.createdBy}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
    import PageHeader from '@/components/PageHeader.vue'
    import { mapActions, mapGetters } from "vuex";
    import DropFile from "@/components/DropFile.vue";
    import FileProgress from "@/components/FileProgress.vue";
    export default {
        components: {
            'page-header': PageHeader,
            DropFile,
            FileProgress
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Finance - Import supplier work item files'
                },
                selected: null,
                files: [],
                tabIndex: 0
            }
        },
        computed: {
            ...mapGetters({
                uploadedFiles: 'suplPayments/getUploadedFiles',
                workItemFileSchemas: 'suplPayments/getWorkItemFileSchemas'
            }),
            options() {
                if (this.workItemFileSchemas && this.workItemFileSchemas.length > 0) {
                    try {
                        return [{ value: null, text: 'SELECT...' },...this.workItemFileSchemas.map(x => { return { value: x.id, text: x.name } })]
                    } catch (err) {
                        console.error(err)
                    }
                }
                return [{ value: null, text: 'SELECT...' }]
            }
        },
        methods: {
            ...mapActions({
                loadUploadedFiles: "suplPayments/getUploadedFiles",
                uploadWorkItemFiles: "suplPayments/uploadWorkItemFiles",
                getWorkItemFileSchemas: "suplPayments/getWorkItemFileSchemas"
            }),
            handleChange(ev) {
                this.files = ev
            },
            uploadFiles() {
                let { files, selected } = this;
                const formData = new FormData();
                formData.append("selectedFileType", selected);
                files.forEach((file) => {
                    formData.append("selectedFiles", file);
                });
                let self = this
                this.uploadWorkItemFiles(formData)
                    .then(response => {
                        self.$refs['dropFile'].init()
                        this.files = []
                        this.selected = null
                        console.log('-uploadFiles: ', response)
                    })
            }
        },
        beforeMount() {
            this.getWorkItemFileSchemas()
            this.loadUploadedFiles()
        },
    }
</script>
<style>
    .upload-main-override {
        display: flex;
        flex-grow: 1;
        align-items: center;
        height: 25vh;
        justify-content: center;
        text-align: center;
    }
</style>